export default __webpack_public_path__ + "static/media/q1.875c5a92.png";